import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actionCommon, actionDoctor } from "../redux/actions";
import { VideoCall } from "../commonPage";
import { Buttton, Header } from "../components";
import { GoMute, GoUnmute } from "react-icons/go";
import { MdOutlineCall, MdOutlineCallEnd } from "react-icons/md";
import { PiVideoCamera, PiVideoCameraSlash } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { useAlert, useToast } from "../contexts";

const VideoCallPage = ({ loginData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { showAlert } = useAlert();
    const { showToast } = useToast();
    const location = useLocation();
    const { appointment } = location.state || {};
    const [isMuted, setIsMuted] = useState(false);
    const [isCameraOn, setIsCameraOn] = useState(true);
    const [inCall, setInCall] = useState(false);
    const [isPermissionGranted, setIsPermissionGranted] = useState(false); // New state for permissions

    const handleToggle = () => {
        setIsMuted((prev) => !prev);
    };
    const handleCameraToggle = () => {
        setIsCameraOn((prev) => !prev);
    };
    const handleToggle2 = () => {
        if (!inCall) {
            if (appointment?.appointmentGuid && loginData?.userGuid) {
                dispatch(
                    actionCommon.postGetAuthToken(
                        { channel: appointment?.appointmentGuid, uid: loginData?.userGuid },
                        (error, response) => {
                            if (error) {
                                if (error.data?.statusCode === 400) {
                                    if (error.data.error?.ValidationErrors) {
                                        error.data.error.ValidationErrors.forEach((validationError) => {
                                            console.error(`${t("Field")}: ${validationError.Field} - ${t("Message")}: ${validationError.Message}`);
                                            showAlert("danger", validationError.Message, `${t("Error")} : ${validationError.Field}`);
                                        });
                                    } else {
                                        showAlert("danger", t("Invalid_credentials"), `${t("Error")}!`);
                                    }
                                } else {
                                    showAlert("danger", t("unexpected_error"), `${t("Error")}!`);
                                }
                            } else if (response && response.status === 200) {
                                const token = response?.data?.result?.data?.token;
                                showToast(t("success"), 5000, true, "top-end toast-success");
                                setInCall(true); // Set inCall to true
                            }
                        }
                    )
                );
            }
        } else {
            setInCall(false);
        }
    };

    // Check permissions before starting the video call
    const checkPermissions = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
            stream.getTracks().forEach(track => track.stop()); // Stop the stream to release the devices
            setIsPermissionGranted(true); // If permissions granted, update state
        } catch (err) {
            showAlert("danger", "Camera or Microphone permission denied.", "Error");
        }
    };

    useEffect(() => {
        // Check for permissions before loading the component
        checkPermissions();

        if (appointment?.appointmentGuid && loginData?.currencyCode) {
            dispatch(
                actionDoctor.getAllAppointmentDetail(
                    appointment?.appointmentGuid || '9e3228d4-3735-4f2a-a14a-2c6238df9817',
                    loginData?.currencyCode || "CHF",
                    false
                )
            );
        }
    }, [appointment?.appointmentGuid, dispatch, loginData?.currencyCode, loginData?.userGuid]);

    const getAllAppointmentDetailData = useSelector(
        (state) => state.doctor.getAllAppointmentDetailData?.data
    );

    return (
        <VideoCall.AgoraClient>
            <div className="video-call-page">
                <div className="video-call-remote-section">
                    <h2 className="">Remote</h2>
                    <VideoCall.RemoteVideoView />
                </div>
                <div className="video-call-button-section">
                    <Buttton.Buttton
                        className={`vc-btn ${isMuted ? "btn-solid-Aqua_Teal" : "btn-border-Aqua_Teal"}`}
                        onClick={handleToggle}
                        children={isMuted ? <GoMute /> : <GoUnmute />}
                    />
                    <Buttton.Buttton
                        className={`vc-btn ${isCameraOn ? "btn-border-Aqua_Teal" : "btn-solid-Aqua_Teal"}`}
                        onClick={handleCameraToggle}
                        children={isCameraOn ? <PiVideoCamera /> : <PiVideoCameraSlash />}
                    />
                    <Buttton.Buttton
                        className={`vc-btn ${inCall ? "btn-border-red" : "btn-solid-Aqua_Teal"}`}
                        onClick={handleToggle2}
                        children={inCall ? <MdOutlineCallEnd /> : <MdOutlineCall />}
                    />
                </div>
                <div className="video-call-you-section">
                    {isPermissionGranted && (
                        <VideoCall.LocalVideoView
                            isCameraOn={isCameraOn}
                        />
                    )}
                </div>
            </div>
        </VideoCall.AgoraClient>
    );
};

export default VideoCallPage;
